.pill {
  position: fixed;
  top: calc(var(--nav-height) + 16px);
  right: 24px;
  z-index: 8000;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: var(--radius-pill);
  background: var(--brand-ember);
  color: var(--brand-paper);
  border: 1px solid var(--brand-ember);
  font-family: var(--font-body);
  font-size: 0.875rem;
  font-weight: 650;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
}

.label {
  letter-spacing: 0.01em;
}

.count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: var(--radius-pill);
  background: var(--brand-paper);
  color: var(--brand-ember);
  font-size: 0.75rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 640px) {
  .pill {
    top: calc(var(--nav-height) + 10px);
    right: 16px;
  }
}
